import { formartOnlyNumber } from '@unicus/react-ui-kit';

const postalCodeValidator = (_, value = '') => {
  const formattedValue = formartOnlyNumber(value);

  if (!formattedValue) {
    return Promise.resolve();
  }

  if (formattedValue.length < 8 && formattedValue.length > 0) {
    return Promise.reject(new Error('Preencha o campo CEP'));
  }

  return Promise.resolve();
};

export default postalCodeValidator;
